const MIN_SIDE = 180;
const MIN_LONG_SIDE = 320;
const MIN_DURATION = 120;
const LONG_DURATION = 600;
const MIN_INTERVAL = 30000;

const isKnownDuration = (duration) => Number.isFinite(duration) && duration > 0;

const isSet = (value) => value !== null && value !== undefined;

export const getDefaultParams = ({ nodeEnv, hostname }) => {
  // TODO надо добавить продакшеновый домен для них
  if (hostname === "sportsru.sprinttyott.com") {
    return { partnerId: 509705, category: 0 };
  }
  if (nodeEnv !== "production") {
    return { partnerId: 291193, category: 0 };
  }
  return { partnerId: 1367052, category: 0, impId: 1 };
};

export const buildAdConfig = ({
  vast,
  defaults,
  pageUrl,
  contentUrl,
  duration,
  isLive,
  width,
  height,
  vastUrl,
}) => {
  const creative = vast || {};
  const pick = (value, fallback) => (isSet(value) ? value : fallback);

  const config = {
    partnerId: pick(creative.yandexPartnerId, defaults.partnerId),
    category: pick(creative.yandexCategory, defaults.category),
    targetRef: pageUrl,
    videoContentUrl: contentUrl,
    preferableAdSize: {
      width: Math.round(width),
      height: Math.round(height),
    },
  };

  const impId = pick(creative.yandexImpId, defaults.impId);
  if (isSet(impId)) config.impId = impId;

  const statId = creative.yandexPartnerStatId;
  if (isSet(statId) && statId !== "") config.partnerStatId = statId;

  if (isLive) {
    config.videoContentDuration = "infinity";
  } else if (isKnownDuration(duration)) {
    config.videoContentDuration = Math.round(duration);
  }

  if (vastUrl) config.vastUrl = vastUrl;

  return config;
};

export const adLimit = ({ duration, isLive }) =>
  isLive || !isKnownDuration(duration) || duration >= LONG_DURATION ? 4 : 2;

export const checkRequest = ({
  width,
  height,
  duration,
  isLive,
  now,
  lastRequestAt,
  impressions,
  userInitiated,
}) => {
  const long = Math.max(width, height);
  const short = Math.min(width, height);
  if (long < MIN_LONG_SIDE || short < MIN_SIDE) return "SIZE";

  if (!isLive && isKnownDuration(duration) && duration < MIN_DURATION) {
    return "SHORT";
  }

  if (
    !userInitiated &&
    isSet(lastRequestAt) &&
    now - lastRequestAt < MIN_INTERVAL
  ) {
    return "INTERVAL";
  }

  if (impressions >= adLimit({ duration, isLive })) return "LIMIT";

  return null;
};
